import React from 'react';

//styles
import { Label } from './StatusLabel.styled';

interface IStatusLabel {
  text: boolean | string;
}

export const StatusLabel = ({ text }: IStatusLabel) => {
  const pickLabelTheme = (labelText: string) => {
    switch (labelText) {
      case 'isključeno':
      case 'neaktivan':
      case 'Unpaid':
      case 'Neplaćeno':
      case 'unpublished':
      case 'neobjavljeno':
        return 'red';

      case 'uključeno':
      case 'aktivan':
      case 'published':
      case 'objavljeno':
        return 'green';

      case 'Paid':
      case 'Plaćeno':
        return 'grey';
      default:
        return undefined;
    }
  };

  const isTextString = () => {
    if (typeof text === 'string') return text;
    else return text ? 'uključeno' : 'isključeno';
  };

  return <Label color={pickLabelTheme(isTextString())}>{isTextString()}</Label>;
};
